import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/compat/router';
import { sanitizeUrl } from '@braintree/sanitize-url';

import useTranslation from 'src/hooks/use-translation';
import useStores from 'shared/hooks/use-stores';

import { Button } from 'shared/components';

const getCheckoutUrl = (): string => {
  const url = new URL(window.location.href);
  const currentQueryParams = url.searchParams;
  currentQueryParams.delete('autoLogin');
  const queryParamString = currentQueryParams.toString();

  return sanitizeUrl(`${url.origin}${url.pathname}${queryParamString ? `?${queryParamString}` : ''}`);
};

export function OAuthLogin(): JSX.Element | null {
  const { t } = useTranslation();
  const { Cart, User } = useStores();
  const { id: dispensaryId } = Cart.dispensary;
  const { isLoggedIn } = User;
  const formRef = useRef<HTMLFormElement>(null);
  const { query } = useRouter() ?? {};
  const { autoLogin, token } = query ?? {};
  const checkoutUrl = getCheckoutUrl();

  useEffect(() => {
    if (autoLogin === 'true' && !token && formRef.current) {
      formRef.current.submit();
    }
  }, [autoLogin, token]);

  if (isLoggedIn) {
    return null;
  }

  return (
    <form ref={formRef} method='post' action='/api/v2/auth/omniauth_generic'>
      <input type='hidden' name='checkout_url' value={checkoutUrl} />
      <input type='hidden' name='dispensary_id' value={dispensaryId} />
      <input type='hidden' name='promo' value={Cart.coupon?.code ?? null} />

      {autoLogin !== 'true' && <Button type='submit'>{t('checkout.login-button', 'Login')}</Button>}
    </form>
  );
}
